export default function isMobile() {
  // 判断是否移动端
  const u = navigator.userAgent
  return !!u.match(/AppleWebKit.*Mobile.*/) || u.indexOf('mqqbrowser') > -1
}
